import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";

export const REFRESH_DOCUMENT_MESSAGES = gql`
  subscription refreshDocumentMessages($documentId: Int!) {
    refreshDocumentMessages(documentId: $documentId) {
      documentIds
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
